var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-qa":"common-benefits"}},[_c('Benefits',{attrs:{"data-qa":"benefits"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }